import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from '../../shared/_services/theme.service';
import { ApiService } from '../../shared/_services/api.service';
import { ChangeLanguageComponent } from '../components/change-language/change-language.component';

type FormStatus = 'idle' | 'prefilling' | 'loading' | 'success' | 'error';

@Component({
	selector: 'app-recesso',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, ChangeLanguageComponent],
	templateUrl: './recesso.component.html',
})
export class RecessoComponent implements OnInit {
	form!: FormGroup;
	logoUrl = '';
	stepImage = '';
	isImatra = false;
	status: FormStatus = 'idle';
	readonly currentYear = new Date().getFullYear();

	private token = '';
	private tenantId = 0;

	constructor(
		private readonly fb: FormBuilder,
		private readonly route: ActivatedRoute,
		private readonly themeService: ThemeService,
		private readonly apiService: ApiService,
	) {}

	ngOnInit(): void {
		this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
		this.tenantId = Number(this.route.snapshot.queryParamMap.get('tenantId')) || 0;

		if (this.tenantId) {
			this.themeService.setTenant(this.tenantId);
		}
		this.themeService.init().then(() => {
			this.logoUrl = this.themeService.getLogoUrl();
			this.stepImage = this.themeService.getStepImage(false);
			this.isImatra = this.themeService.getTenantId() === 1;
		});

		this.form = this.fb.group({
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			phone: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			policyNumber: ['', Validators.required],
		});

		if (this.token) {
			this.status = 'prefilling';
			this.apiService.getWithdrawalInfo(this.token, 'it').subscribe({
				next: (info) => {
					this.form.patchValue({
						firstName: info.firstName ?? '',
						lastName: info.lastName ?? '',
						phone: info.phone ?? '',
						email: info.email ?? '',
						policyNumber: info.policyNumber ?? '',
					});
					this.status = 'idle';
				},
				error: () => { this.status = 'idle'; },
			});
		}
	}

	invia(): void {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}
		this.status = 'loading';
		this.apiService.inviaRecesso({
			token: this.token,
			tenantId: this.tenantId,
			language: 'it',
			...this.form.value,
		}).subscribe({
			next: () => { this.status = 'success'; },
			error: () => { this.status = 'error'; },
		});
	}

	isInvalid(field: string): boolean {
		const ctrl = this.form.get(field);
		return !!(ctrl?.invalid && ctrl?.touched);
	}
}
